// #region COMPONENTS COMPOSABLES
import AcceptedRequest from '../views/accepted-request/AcceptedRequest.vue';
// #endregion

export default [
  {
    path: '/detalle-registro',
    name: 'AcceptedRequest',
    component: AcceptedRequest,
    meta: {
      title: 'Detalle registro',
      staticBreadCrumbs: [
        {
          text: 'Transporte Terrestre',
          link: 'https://www.transportes.gob.es/transporte_terrestre',
        },
        {
          text: 'Viajeros de autobús y tren',
          link: 'https://www.transportes.gob.es/transporte_terrestre#Viajeros_de_autobus_y_tren',
        },
        {
          key: 'main',
          dynamic: true,
          // text: '',
          // link: STTEDRA_URL_AMPLIFY_INFORMATION || 'https://www.transportes.gob.es/transporte_terrestre/verano-joven',
          link: '',
          route: 'Home',
        },
        {
          text: 'Registro',
          link: '',
          route: 'Register',
        },
        {
          text: 'Detalle de registro',
          link: '',
        },
      ],
    },
  },
];
